var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemperature = function SvgTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "temperature_svg2__a",
    x1: 48.84,
    x2: 145.84,
    y1: 174.79,
    y2: 35.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#temperature_svg2__a",
    id: "temperature_svg2__b",
    x1: 43.43,
    x2: 140.43,
    y1: 171.02,
    y2: 32.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#temperature_svg2__a",
    id: "temperature_svg2__c",
    x1: 77.53,
    x2: 174.53,
    y1: 194.82,
    y2: 55.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#temperature_svg2__a",
    id: "temperature_svg2__d",
    x1: 66.51,
    x2: 163.51,
    y1: 187.12,
    y2: 48.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#temperature_svg2__a",
    id: "temperature_svg2__e",
    x1: 55.48,
    x2: 152.48,
    y1: 179.43,
    y2: 40.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#temperature_svg2__a",
    id: "temperature_svg2__f",
    x1: 44.46,
    x2: 141.46,
    y1: 171.74,
    y2: 32.74
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M91.76 131.69V52.33c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v79.37c-10.18 1.68-17.98 10.52-17.98 21.17 0 11.85 9.64 21.49 21.48 21.49s21.48-9.64 21.48-21.49c0-10.65-7.8-19.49-17.98-21.17Zm-3.5 35.66c-7.98 0-14.48-6.5-14.48-14.49s6.5-14.48 14.48-14.48 14.48 6.5 14.48 14.48-6.5 14.49-14.48 14.49",
    style: {
      fill: "url(#temperature_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.03 116.72V28.94c0-14.76-12.01-26.78-26.77-26.78S61.49 14.17 61.49 28.94v87.79a44.97 44.97 0 0 0-18.2 36.14c0 24.8 20.17 44.97 44.97 44.97s44.96-20.18 44.96-44.97a44.97 44.97 0 0 0-18.2-36.14Zm-26.77 74.12c-20.94 0-37.97-17.04-37.97-37.97 0-12.6 6.23-24.35 16.66-31.44.96-.65 1.53-1.74 1.53-2.89v-89.6c0-10.9 8.87-19.78 19.77-19.78s19.77 8.87 19.77 19.78v89.6c0 1.16.57 2.24 1.53 2.9a37.99 37.99 0 0 1 16.66 31.44c0 20.94-17.03 37.97-37.96 37.97Z",
    style: {
      fill: "url(#temperature_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.21 95.91h-18.2c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5h18.2c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5",
    style: {
      fill: "url(#temperature_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.21 72.42h-18.2c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5h18.2c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5",
    style: {
      fill: "url(#temperature_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.21 48.92h-18.2c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5h18.2c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5",
    style: {
      fill: "url(#temperature_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 32.43h18.2c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5h-18.2c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5",
    style: {
      fill: "url(#temperature_svg2__f)"
    }
  }));
};
export default SvgTemperature;